import React from 'react';
import { useObservable } from 'react-use-observable';

import { Tag, Typography } from 'antd';

import { EPaymentMethod, type IRefundRequest, type ShoppingDelivery } from 'v2/interfaces/shopping';
import { refundRequestFactory } from 'v2/services/shopping/refundRequest';

interface BuyerDetailsProps {
  delivery: ShoppingDelivery;
}

export function BuyerDetails({ delivery }: BuyerDetailsProps) {
  const [refundRequest] = useObservable<IRefundRequest>(
    () => refundRequestFactory.buyerFindRefundByInvoiceId(delivery.invoice_id),
    []
  );

  function getPaymentMethodName(invoice: ShoppingDelivery) {
    if (invoice.payment_method.id === EPaymentMethod.PIX_AUTOMATICO) return invoice.payment_method.method;
    return invoice.payment_method.name;
  }

  return (
    <div className='flex flex-col gap-1'>
      {delivery.customer.name && (
        <div className='text-sm'>
          <Typography.Text>Nome: </Typography.Text>
          <Typography.Text type='secondary'>{delivery.customer.name}</Typography.Text>
        </div>
      )}
      {delivery.customer.email && (
        <div className='text-sm'>
          <Typography.Text>E-mail: </Typography.Text>
          <Typography.Text type='secondary'>{delivery.customer.email}</Typography.Text>
        </div>
      )}
      {delivery.customer.celphone && (
        <div className='text-sm'>
          <Typography.Text>Fone: </Typography.Text>
          <Typography.Text type='secondary'>{delivery.customer.celphone}</Typography.Text>
        </div>
      )}
      {delivery.payment_method.name && (
        <div className='text-sm'>
          <Typography.Text>Forma de pagamento: </Typography.Text>
          <Typography.Text type='secondary'>{getPaymentMethodName(delivery)}</Typography.Text>
        </div>
      )}
      {delivery.installments ? (
        <div className='text-sm'>
          <Typography.Text>Parcelamento: </Typography.Text>
          <Typography.Text type='secondary'>{delivery.installments}x</Typography.Text>
        </div>
      ) : null}
      {delivery.card_number && (
        <div className='text-sm'>
          <Typography.Text>Cartão: </Typography.Text>
          <Typography.Text type='secondary'>{delivery.card_number}</Typography.Text>
        </div>
      )}
      {!refundRequest?.exist &&
        refundRequest?.refund_due_date &&
        delivery.payment_method.id !== EPaymentMethod.BOLETO_PARCELADO && (
          <div className='flex items-center gap-2 text-sm'>
            <span>
              <Typography.Text>Prazo para reembolso: </Typography.Text>
              <Typography.Text type='secondary'>{refundRequest?.refund_due_date}</Typography.Text>
            </span>
            {refundRequest?.expired && <Tag color='error'>Expirado</Tag>}
          </div>
        )}
    </div>
  );
}
